@if (showBackButton) {
  <div class="inner-navigation">
    <div class="back" (click)="navigateBack()">
      <p class="text-button-small">{{ 'insurance-details.navigation-back' | translate }}</p>
    </div>
  </div>
}
<div class="block-title">
  <h3>{{ 'insurance-details.block-title-insurance-info' | translate }}</h3>
</div>
@if (petData) {
  <div class="rows-container split-equally">
    <div class="container-title">
      <p class="tag-12">{{ 'insurance-details.container-title-standard-insurance' | translate }}</p>
    </div>
    <div class="rows">
      <div class="row">
        <div class="title">
          <p class="body-14">{{ 'insurance-details.row-title-sum-insured' | translate }}</p>
        </div>
        <div class="value">
          <p class="subtitle-14">{{ petData.overall_sum_insured | currency:'CHF':'symbol':'1.0-0' }}</p>
        </div>
      </div>
      <div class="row">
        <div class="title">
          <p class="body-14">{{ 'insurance-details.row-title-excess' | translate }}</p>
        </div>
        <div class="value">
          <p class="subtitle-14">{{ petData.annual_franchise  | currency:'CHF':'symbol':'1.0-0' }}</p>
        </div>
      </div>
      <div class="row">
        <div class="title">
          <p class="body-14">{{ 'insurance-details.row-title-cost-coverage' | translate }}</p>
        </div>
        <div class="value">
          <p class="subtitle-14">{{ showCurrentDeductible() }}%</p>
        </div>
      </div>
      <div class="row">
        <div class="title">
          <p class="body-14">{{ 'insurance-details.row-title-insurance-date' | translate }}</p>
        </div>
        <div class="value">
          <p class="subtitle-14">{{ petData.start_date | date: 'dd.MM.yyyy' }}</p>
        </div>
      </div>
      <div class="row">
        <div class="title">
          <p class="body-14">{{ 'insurance-details.row-title-renew-date' | translate }}</p>
        </div>
        <div class="value">
          <p class="subtitle-14">{{ getRenewDate() | date: 'dd.MM.yyyy' }}</p>
        </div>
      </div>
      <div class="row">
        <div class="title">
          <p class="body-14">{{ 'insurance-details.row-title-overall-price' | translate }}</p>
        </div>
        <div class="value">
          <p class="subtitle-14">CHF {{ getSubscriptionCost() | number: '1.2-4' }}</p>
        </div>
      </div>
    </div>
  </div>
  <ng-template #coverageInfoTemplate let-translationKey='translationKey' let-useUpToSubtitle="useUpToSubtitle"
    let-limit="limit" let-percents="percents">
    <div class="info-container">
      <div class="content">
        <div class="header">
          <div class="title">
            <p
            class="subtitle-14">{{ ('insurance-details.' + translationKey + '.title') | translate }}</p>
          </div>
          @if (('insurance-details.' + translationKey + '.modal-title') | translate) {
            <div class="info-icon"
              (click)="openInfo(('insurance-details.' + translationKey + '.title'), ('insurance-details.' + translationKey + '.modal-message'))">
              <mat-icon svgIcon="i-icon"></mat-icon>
            </div>
          }
        </div>
        <div class="text">
          @if (!useUpToSubtitle) {
            <p
              class="body-12"
            >{{ 'insurance-details.coverage-subtitle-default' | translate: { limit: (limit | currency:'CHF':'symbol':'1.0-0') } }}</p>
          }
          @if (useUpToSubtitle) {
            <p
              class="body-12">{{
              'insurance-details.coverage-subtitle-up-to' | translate: {
              percents: percents,
              limit: (limit | currency:'CHF':'symbol':'1.0-0')
            }
          }}</p>
        }
      </div>
    </div>
  </div>
</ng-template>
  <ng-container *ngTemplateOutlet="coverageInfoTemplate; context: {
    translationKey: 'overall-sum-insured',
    limit: petData.overall_sum_insured
  }"></ng-container>
@if (petData.accident_and_illness_coverage.coverage_selected) {
    <ng-container *ngTemplateOutlet="coverageInfoTemplate; context: {
      translationKey: 'accident-and-illness-coverage',
      limit: petData.accident_and_illness_coverage.sublimit_sum
    }"></ng-container>
}
@if (petData.illness_advanced_treatment_coverage.coverage_selected) {
    <ng-container *ngTemplateOutlet="coverageInfoTemplate; context: {
      translationKey: 'illness-advanced-treatment-coverage',
      limit: petData.illness_advanced_treatment_coverage.sublimit_sum
    }"></ng-container>
}
@if (petData.illness_complementary_treatment_coverage.coverage_selected) {
    <ng-container *ngTemplateOutlet="coverageInfoTemplate; context: {
      translationKey: 'illness-complementary-treatment-coverage',
      limit: petData.illness_complementary_treatment_coverage.sublimit_sum
    }"></ng-container>
}
@if (petData.illness_behavioural_treatment_coverage.coverage_selected) {
    <ng-container *ngTemplateOutlet="coverageInfoTemplate; context: {
      translationKey: 'illness-behavioural-treatment-coverage',
      limit: petData.illness_behavioural_treatment_coverage.sublimit_sum
    }"></ng-container>
}
@if (petData.accident_dental_treatment_coverage.coverage_selected) {
    <ng-container *ngTemplateOutlet="coverageInfoTemplate; context: {
      translationKey: 'accident-dental-treatment-coverage',
      limit: petData.accident_dental_treatment_coverage.sublimit_sum
    }"></ng-container>
}
@if (petData.illness_dental_treatment_coverage.coverage_selected) {
    <ng-container *ngTemplateOutlet="coverageInfoTemplate; context: {
      translationKey: 'illness-dental-treatment-coverage',
      limit: petData.illness_dental_treatment_coverage.sublimit_sum
    }"></ng-container>
}
@if (petData.emergency_minding_coverage.coverage_selected) {
    <ng-container *ngTemplateOutlet="coverageInfoTemplate; context: {
      translationKey: 'emergency-minding-coverage',
      limit: petData.emergency_minding_coverage.sublimit_sum
    }"></ng-container>
}
@if (petData.emergency_treatment_coverage.coverage_selected) {
    <ng-container *ngTemplateOutlet="coverageInfoTemplate; context: {
      translationKey: 'emergency-treatment-coverage',
      limit: petData.emergency_treatment_coverage.sublimit_sum
    }"></ng-container>
}
@if (petData.worldwide_protection_coverage.worldwide_protection) {
    <ng-container *ngTemplateOutlet="coverageInfoTemplate; context: {
      translationKey: 'worldwide-protection-coverage',
      limit: petData.worldwide_protection_coverage.sum_insured
    }"></ng-container>
}
@if (petData.preexisting_conditions_coverage.preexisting_conditions || petData.medical_food_coverage.coverage_selected || petData.preventive_care_coverage.coverage_selected) {
  <div class="container-title">
    <p class="tag-12">{{ 'insurance-details.container-title-additional-coverage' | translate }}</p>
  </div>
}
@if (petData.preexisting_conditions_coverage.preexisting_conditions) {
    <ng-container *ngTemplateOutlet="coverageInfoTemplate; context: {
      translationKey: 'preexisting-conditions-coverage',
      limit: petData.preexisting_conditions_coverage.sum_insured_current_year
    }"></ng-container>
}
@if (petData.medical_food_coverage.coverage_selected) {
    <ng-container *ngTemplateOutlet="coverageInfoTemplate; context: {
      translationKey: 'medical-food-coverage',
      limit: petData.medical_food_coverage.sublimit_sum,
      percents: petData.medical_food_coverage.sublimit_percentage,
      useUpToSubtitle: true
    }"></ng-container>
}
@if (petData.preventive_care_coverage.coverage_selected) {
    <ng-container *ngTemplateOutlet="coverageInfoTemplate; context: {
      translationKey: 'preventive-care-coverage',
      limit: petData.preventive_care_coverage.sublimit_sum
    }"></ng-container>
}
<div class="actions">
  <button class="button primary text-button-small" (click)="editInsuranceInfo()">
    <span class="button-text">{{ 'insurance-details.edit-insurance-info' | translate }}</span>
  </button>
</div>
@if (!isCancelled) {
  <div class="actions">
    <button class="button white text-button-small" (click)="cancelInsurance()">
      <span class="button-text">{{ 'insurance-details.cancel-insurance' | translate }}</span>
    </button>
  </div>
}
}
